export default __webpack_public_path__ + "static/bg-superhuman-ai-34e662009bc7a73a8eb54825dfe7de0e.jpg";